import React, {useState} from 'react';
import Translate, {t} from "../../../../../../../../components/Translate";
import Input from "../../../../../../../../components-new/form/Input";
import {addWebhook} from "../../../../../../../../services/company/api";
import config from "../../../../../../../../config";
import WebhooksModal from "./WebhooksModal";
import Field from "../../../../../../../../components-new/form/Field";
import BlueButton from "../../../../../../../../components-new/buttons/BlueButton";
import SilverButton from "../../../../../../../../components-new/buttons/SilverButton";
import TranslateProperty from "../../../../../../../../components/TranslateProperty";
import DropdownSelect from "../../../../../../../../components-new/form/DropdownSelect";
import IntegrationIds from "./IntegrationIds";

/*
 * Where the bot posts when something happens.
 *
 * The four inputs were a centred column of unlabelled boxes - a URL, a header
 * name, a value and a type - with nothing saying which was which beyond their
 * placeholder, and the placeholder disappears the moment you type. They are
 * labelled fields in a grid now.
 */
const Webhooks = ({
                      client,
                      webhooks,
                      user,
                      updateWebhooksState,
                      setUpdateWebhooksState,
                      addNotification
                  }) => {

    const [api, setApi] = useState('');
    const [token, setToken] = useState('');
    const [headerName, setHeaderName] = useState('');
    const [type, setType] = useState(config.webhookTypes[0].value);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const onApiChange = (event) => setApi(event.target.value.trim());
    const onTokenChange = (event) => setToken(event.target.value.trim());
    const onHeaderNameChange = (event) => setHeaderName(event.target.value.trim());

    const saveWebhook = () => {
        if (!api) return;
        addWebhook(client.id, api, token, type, headerName)
            .then(() => {
                setUpdateWebhooksState(!updateWebhooksState);
                setApi('');
                setToken('');
                setHeaderName('');
                setType(config.webhookTypes[0].value);
                addNotification('added', config.notificationLevels.success);
            })
            .catch(error => {
                const errorMessage = error.response.data;
                if (errorMessage === 'Invalid API URL format') {
                    addNotification("invalidApiUrlFormat", config.notificationLevels.error)
                } else if (errorMessage === 'API must not be empty') {
                    addNotification("apiMustNotBeEmpty", config.notificationLevels.error)
                } else {
                    addNotification("somethingWentWrong", config.notificationLevels.error)
                }
            });
    };

    const webhookOptions = config.webhookTypes.map((w) => ({value: w.value, label: t({text: w.key, user})}));
    const selectedType = webhookOptions.find(option => option.value === type) || webhookOptions[0];

    return (
        <div className="stg-page">
            <div className="stg-card">
                <div className="stg-card__head">
                    <div>
                        <p className="stg-card__note"><Translate text="webhooksInfo"/></p>
                    </div>

                    <SilverButton size="md" width={'auto'} onClick={() => setIsModalOpen(true)}>
                        <Translate text={'showWebhooks'}/> ({webhooks.length})
                    </SilverButton>
                </div>

                <IntegrationIds client={client}/>

                <div className="stg-grid">
                    <Field label="webhookUrl" required htmlFor="webhook-url" className="stg-grid__wide">
                        <Input
                            id="webhook-url"
                            className="stg-input"
                            placeholder={'https://example.com/hook'}
                            name={'api'}
                            value={api}
                            onChange={onApiChange}
                        />
                    </Field>

                    <Field label="webhookEvent" htmlFor="webhook-type" help="webhookEventHelp">
                        <DropdownSelect
                            selectedValue={selectedType}
                            options={webhookOptions}
                            onChange={e => setType(e.value)}
                            styles={{width: '100%', height: '40px'}}
                            variant={'outline'}
                        />
                    </Field>

                    <Field label="headerName" htmlFor="webhook-header" help="webhookHeaderHelp">
                        <TranslateProperty properties={[{key: 'placeholder', value: 'headerName'}]}>
                            <Input
                                id="webhook-header"
                                className="stg-input"
                                name={'headerName'}
                                value={headerName}
                                onChange={onHeaderNameChange}
                            />
                        </TranslateProperty>
                    </Field>

                    <Field label="value" htmlFor="webhook-value" help="webhookValueHelp" className="stg-grid__wide">
                        <TranslateProperty properties={[{key: 'placeholder', value: 'value'}]}>
                            <Input
                                id="webhook-value"
                                className="stg-input"
                                name={'token'}
                                value={token}
                                onChange={onTokenChange}
                            />
                        </TranslateProperty>
                    </Field>
                </div>

                <div className="stg-add-row" style={{marginTop: '16px', justifyContent: 'flex-end'}}>
                    <BlueButton size="md" width={'120px'} onClick={saveWebhook} disabled={!api}>
                        <Translate text={'add'}/>
                    </BlueButton>
                </div>
            </div>

            {isModalOpen &&
                <WebhooksModal
                    isOpen={isModalOpen}
                    cancelAction={() => setIsModalOpen(false)}
                    updateWebhooksState={updateWebhooksState}
                    setUpdateWebhooksState={setUpdateWebhooksState}
                    webhooks={webhooks}
                    webhooksData={webhooks}
                    addNotification={addNotification}
                />
            }
        </div>
    );
};

export default Webhooks;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/resources/webhooks/Webhooks.jsx